import { navigate } from "vike/client/router"
import Menu from "aldoo-ra/Menu"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"

export default function ProductPostPurchase({ item, onAction }) {
  return (
    <div className="flex flex-col items-center justify-center mb-5">
      <Typography variant="admin_body" className="mb-4">
        {item.message}
      </Typography>
      <Menu
        menuData={item?.actions[0]}
        renderAs="hlist"
        itemWidth="150px"
        itemsAsLinks={false}
        menuItemRender={(menuItem) => {
          const url = menuItem?.link?.[0]?.url || "/account"
          return (
            <Button
              variant="admin_primary"
              onClick={() => { onAction?.(); navigate(url) }}
            >
              {menuItem?.label}
            </Button>
          )
        }}
      />
    </div>
  )
}
